import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Consultation from "@/pages/Consultation";
import Workshops from "@/pages/Workshops";
import WorkshopDetail from "@/pages/WorkshopDetail";
import Downloads from "@/pages/Downloads";
import DownloadDetail from "@/pages/DownloadDetail";
import Shop from "@/pages/Shop";
import ShopProduct from "@/pages/ShopProduct";
import SeoLanding from "@/pages/SeoLanding";
import { seoPages } from "@/data/seoPages";
import Booking from "@/pages/Booking";
import CaseStudies from "@/pages/CaseStudies";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refunds from "@/pages/Refunds";
import Shipping from "@/pages/Shipping";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
    return (
        <div className="App min-h-screen bg-ink-900 text-white">
            <LanguageProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        {/* Admin routes — no marketing layout */}
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />

                        {/* Marketing site */}
                        <Route
                            path="*"
                            element={
                                <Layout>
                                    <Routes>
                                        <Route path="/" element={<Home />} />
                                        <Route path="/about" element={<About />} />
                                        <Route path="/case-studies" element={<CaseStudies />} />
                                        <Route path="/consultation" element={<Consultation />} />
                                        <Route path="/workshops" element={<Workshops />} />
                                        <Route path="/workshops/:slug" element={<WorkshopDetail />} />
                                        <Route path="/downloads" element={<Downloads />} />
                                        <Route path="/downloads/:slug" element={<DownloadDetail />} />
                                        <Route path="/download" element={<Navigate to="/downloads" replace />} />
                                        <Route path="/shop" element={<Shop />} />
                                        <Route path="/shop/:slug" element={<ShopProduct />} />
                                        <Route path="/workshop" element={<Navigate to="/workshops" replace />} />
                                        <Route path="/book-workshop" element={<Navigate to="/workshops" replace />} />
                                        <Route path="/business-growth-workshop" element={<Navigate to="/workshops" replace />} />
                                        {seoPages.map((p) => (
                                            <Route key={p.slug} path={`/${p.slug}`} element={<SeoLanding slug={p.slug} />} />
                                        ))}
                                        <Route path="/analyse" element={<Navigate to="/consultation" replace />} />
                                        <Route path="/blog" element={<Blog />} />
                                        <Route path="/blog/:slug" element={<BlogDetail />} />
                                        <Route path="/contact" element={<Contact />} />
                                        <Route path="/booking" element={<Booking />} />
                                        <Route path="/terms" element={<Terms />} />
                                        <Route path="/privacy" element={<Privacy />} />
                                        <Route path="/refunds" element={<Refunds />} />
                                        <Route path="/shipping" element={<Shipping />} />
                                        <Route path="/analyze" element={<Navigate to="/consultation" replace />} />
                                        <Route path="/consulting" element={<Navigate to="/consultation" replace />} />
                                        <Route path="/book" element={<Navigate to="/booking" replace />} />
                                        <Route path="*" element={<Navigate to="/" replace />} />
                                    </Routes>
                                </Layout>
                            }
                        />
                    </Routes>
                </BrowserRouter>
            </LanguageProvider>
            <Toaster
                theme="dark"
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#0A0B14",
                        border: "1px solid rgba(212,175,55,0.35)",
                        color: "#fafafa",
                    },
                }}
            />
        </div>
    );
}

export default App;
